import React from "react"
import { FC } from "react"
import { Image, ImageProps } from "react-native"

const FastImage: FC<ImageProps> = props => {
  return <Image {...props} />
}

export default FastImage
